<template>
  <div>
    <div v-if="!statusError">
      <Loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true" />

      <router-view v-if="!loading" />
    </div>
    <div v-if="statusError">
      <Error409 v-if="statusError === 409" />
      <Error404 v-if="statusError !== 409" />
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import Error404 from './Error404'
import Error409 from './Error409'

// @ is an alias to /src
export default {
  name: 'home',
  components: {
    Loading,
    Error404,
    Error409
  },
  data () {
    return {
      loading: true,
      statusError: null
    }
  },
  computed: {
    summary () {
      return this.$store.getters.getSummary
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store.dispatch('setSummary').then(result => {
        this.loading = false
      }).catch(err => {
        this.statusError = err.response.status
      })
    }
  }
}
</script>

<style scoped></style>
